import { TableCell, TableRow, Tooltip } from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import styles from "pages/phNewPendingTasks/style.module.scss";

const SupportChat = () => {
  const tasksList = [
    {
      role: 1,
      status: 1,
      ticket_status: 1,
    },
    {
      role: 2,
      status: 0,
      ticket_status: 0,
    },
    {
      role: 3,
      status: 1,
      ticket_status: 0,
    },
    {
      role: 4,
      status: 0,
      ticket_status: 1,
    },
    {
      role: 5,
      status: 1,
      ticket_status: 1,
    },
    {
      role: 6,
      status: 0,
      ticket_status: 1,
    },
  ];

  return (
    <>
      {tasksList?.map((item: any, index: any, arr: any) => {
        return (
          <TableRow
          // className={classNames(index + 1 === arr.length && styles.lastCells)}
          >
            <TableCell>
              <div className={styles.nameCell}>
                <img
                  src={Images.UserPlaceholderImage}
                  alt="profile_picture"
                  className={styles.profilepic}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Jane Doe</label>
                  <label className={styles.emailLabel}>janedoe@gmail.com</label>
                </div>
              </div>
            </TableCell>
            <TableCell>03103212312</TableCell>
            <TableCell className={classNames(styles.statusCell)}>
              <label
                className={
                  item?.status === 1
                    ? styles.approved
                    : item?.status === 0
                    ? styles.rejected
                    : ""
                }
              >
                {item?.status ? "Signed" : "Not Signed Yet"}
              </label>
            </TableCell>
            <TableCell>
              <div className={styles.nameCell}>
                {item?.publication ? (
                  <>
                    {" "}
                    <img
                      src={Images.UserPlaceholderImage}
                      alt="profile_picture"
                      className={styles.profilepic}
                    />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>Ehya Publication</label>
                    </div>
                  </>
                ) : (
                  <>Independent Author</>
                )}
              </div>
            </TableCell>
            <TableCell className={classNames(styles.statusCell)}>
              <label
                className={
                  item?.ticket_status === 1
                    ? styles.pending
                    : item?.ticket_status === 0
                    ? styles.neutral
                    : ""
                }
              >
                {item?.ticket_status ? "Open" : "Closed"}
              </label>
            </TableCell>
            <TableCell>
              <div className={styles.actionContainer}>
                <Tooltip arrow title="View Support">
                  <div>
                    <Icons.EyeIcon className={styles.icons} />
                  </div>
                </Tooltip>
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default SupportChat;
